var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "post-section-6"
  }, [_c("PortableText", {
    attrs: {
      value: _vm.sectionData.text
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };